module.exports = __webpack_public_path__ + "static/img/Hinee.5617596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hinee.png
// module id = na4P
// module chunks = 1